import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'family_dementia_history'

const OPTIONS = [
  {
    value: 'none',
    translationKey: 'pages.onboarding.familyDementiaHistory.options.none',
  },
  {
    value: 'extended-family',
    translationKey:
      'pages.onboarding.familyDementiaHistory.options.extendedFamily',
  },
  {
    value: 'parent-or-sibling',
    translationKey:
      'pages.onboarding.familyDementiaHistory.options.parentOrSibling',
  },
  {
    value: 'not-sure',
    translationKey: 'pages.onboarding.familyDementiaHistory.options.notSure',
  },
]

const answers: AnswerType[] = [
  {
    emoji: '✅',
    title: 'pages.onboarding.familyDementiaHistory.options.none',
    value: 'none',
  },
  {
    emoji: '👪',
    title: 'pages.onboarding.familyDementiaHistory.options.extendedFamily',
    value: 'extended-family',
  },
  {
    emoji: '🧬',
    title: 'pages.onboarding.familyDementiaHistory.options.parentOrSibling',
    value: 'parent-or-sibling',
  },
  {
    emoji: '❓',
    title: 'pages.onboarding.familyDementiaHistory.options.notSure',
    value: 'not-sure',
  },
]

export default function FamilyDementiaHistoryPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "Do you have a family history of Alzheimer's or dementia?",
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.familyDementiaHistory.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
